import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSquarespaceRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 31 31",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "m7.7 14.4 6.9-7a4.4 4.4 0 0 1 6.3 0 1.1 1.1 0 0 1-.4 1.9 1 1 0 0 1-1.2-.3h-.1a2 2 0 0 0-3 0L9 16.2q-.9.6-1.6 0a1.1 1.1 0 0 1 .2-1.8m15.5.2a1 1 0 0 0-1.7.2l-7 6.9a2 2 0 0 1-3 0 1.1 1.1 0 0 0-2 .4 1 1 0 0 0 .5 1.3 4.4 4.4 0 0 0 6.2-.1l7-7.1a1 1 0 0 0 0-1.6m-10.8 4.6a1 1 0 0 0-.2 1.7q.7.6 1.6 0l7-7.1a2.2 2.2 0 0 1 3.2 0 2.2 2.2 0 0 1 0 3.2l-6.7 6.7a2.2 2.2 0 0 0 3.2 0l5.1-5.2a4.5 4.5 0 0 0-3.1-7.6 4 4 0 0 0-3.2 1.3zm-1-.7 7-7a1.1 1.1 0 0 0-.8-2 1 1 0 0 0-.8.5l-7 7a2 2 0 0 1-3 0 2.2 2.2 0 0 1 0-3.2L13.3 7a2 2 0 0 0-3.1 0l-5.1 5.2a4.5 4.5 0 0 0 3.1 7.6 4 4 0 0 0 3.1-1.3" })
});
export default SvgSquarespaceRegularIcon;
